import {useState, useEffect} from "react";
import { Row, Col } from "../../components/Flexbox";
import FilterBar from "../../components/FilterBar";
import OrdenProduccion from "../../components/OrdenProduccion";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import Text from "../../components/Text";
import Spinner from "../../components/Spinner";
import { DateFormatter } from "../../utils";
import SearchBox from "../../components/SearchBox";
import { useDashboard } from "../../scripts/queries/useDashboardQueries.js";
import { useAuth } from "../../scripts/functions/AuthProvider.js";
const Dashboard = () => {

    const {theme} = useTheme();
    const {userClaims} = useAuth();
    const [currentPage, setCurrentPage] = useState(1);
    const ordersPerPage = 48;
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState("");
    const {data: orders= [], refetch: fetchOrders, isFetching: isFetching, isLoading: loading, dataUpdatedAt} = useDashboard();

    const [lastUpdate, setLastUpdate] = useState(null);

    useEffect(() => {   //Restart the page navigation if a filter is applied
        setCurrentPage(1);
    }, [filter]); 

    useEffect(() => {
        if (dataUpdatedAt) {
            setLastUpdate(new Date(dataUpdatedAt));
        }
    }, [dataUpdatedAt]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setFilter(search)
        }, 3000);

        return () => {
            clearTimeout(timeout);
        }
    }, [search]);

    const filteredOrders = orders.filter(order => {
        if (!filter) return true; //If the filter is empty, show all orders

        const term = filter.toLowerCase();

        //Search criteria
        const customer = order.NomeCliente.toLowerCase().includes(term);
        const id = order.NumOrdem.toString().includes(term);

        return customer || id;
    })

    const totalPages = Math.ceil(filteredOrders.length / ordersPerPage);
    const startIndex = (currentPage - 1) * ordersPerPage;
    const paginatedOrders = filteredOrders.slice(startIndex, startIndex + ordersPerPage)

    const pendingDays = (date) => {

        const fechaEntrega = new Date(date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        fechaEntrega.setHours(0, 0, 0, 0);
        
        // Calculate the difference in milliseconds
        const diffInMs = fechaEntrega - today;
        
        // Convert to days
        const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));
        
        return diffInDays;
    }

    const getPercentage = () => {
        if (orders.length === 0) {
            return 0;
        }

        const count = orders.filter(order => pendingDays(order.FECHA_ENTREGA) < 0).length;
        const percentage = (count / orders.length) * 100;
        return percentage.toFixed(2);
    }

    const percentage = getPercentage();

    return (
        <Col style={{ width:'100%', flex:'none',alignItems:'flex-start', paddingLeft: 64, paddingRight:64, paddingTop:64}}>
            <Row style={{paddingLeft:10, paddingRight:10, width:'100%', flexWrap: 'wrap'}} mobileStyle={{gap: 8}}>
                <Col style={{alignItems:"flex-start", gap: 16}} mobileStyle={{width: '100%'}}>
                    <Text color={theme.ONED} size={27} weight="semibold">¡Hola {userClaims.name}!</Text>
                    <FilterBar style={{justifyContent: 'center', gap: '16px'}}>
                        <SearchBox theme={theme}  style={{width: '281px', height: 36}} value = {search} onChange={setSearch}></SearchBox>
                        <Text weight={400} color={theme.Red}>Retraso: {percentage}%</Text>
                    </FilterBar>
                </Col>
                <Col style={{alignItems:'flex-end'}} mobileStyle={{alignItems: 'flex-start', width: '100%', gap: 8}}>
                    <FilterBar style={{width: '100%', justifyContent: 'flex-end'}}>
                        <Text color={theme.SEVENB} size={15}>{lastUpdate ? DateFormatter(lastUpdate.toString(), "FULL_DATE") : '\u200E'}</Text>
                    </FilterBar>
                    <Text onClick={() => fetchOrders()} style={{cursor:'pointer'}} color={theme.Magenta} size={15}>Actualizar</Text>
                </Col>
            </Row>
            <Row style={{paddingLeft:10, paddingRight:10, marginTop: 32,marginBottom:16, width:'100%'}}>
                <Col style={{alignItems:"flex-start"}}>
                    <Text color={theme.ONED} size={20}>Producción</Text>
                </Col>
            </Row>
            <Col style={{position: 'relative', height: '100%', width:'100%'}}>
                {orders.length > 0 && (
                    <Col>
                        <Row style={{flexWrap: 'wrap', gap:18, justifyContent:'flex-start', paddingLeft:10}}>
                            
                            {paginatedOrders.map(order => (
                                <OrdenProduccion 
                                clientName={order.NomeCliente}
                                orderID={`OP ${order.NumOrdem}`}
                                days={pendingDays(order.FECHA_ENTREGA)}
                                theme={theme}/>
                            ))}
                            
                        </Row>
                        <Row style={{width: '100%', marginTop: 16}}>
                            <button
                            style={{height: 40, width: 70, backgroundColor: theme.Checo, borderRadius: 4, border:'solid 1px', borderColor: theme.Ey}}
                            onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}>
                                <Text color={theme.ONED} weight="medium" size={15}>Prev</Text>
                            </button>
                            <Text style={{paddingLeft: 16, paddingRight:16}}>{currentPage} / {totalPages}</Text>
                            <button
                            style={{height: 40, width: 70, backgroundColor: theme.Checo, borderRadius: 4, border:'solid 1px', borderColor: theme.Ey}}
                            onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))}>
                                <Text color={theme.ONED} weight="medium" size={15}>Sig</Text>
                            </button>
                        </Row>
                    </Col>
                )}
                {loading && orders.length === 0 && (
                    <Col style={{justifyContent: 'center', alignItems: 'center', minHeight: 500, width:'100%', backgroundColor: theme.Checo}}>
                        <Spinner theme={theme}/>
                    </Col>
                )}
                {(isFetching || loading) && orders.length > 0 && (
                    <Col style={{position: 'absolute', justifyContent: 'center', alignItems: 'center', height: '100%', width:'100%', backgroundColor: theme.Checo}}>
                        <Spinner theme={theme}/>
                    </Col>
                )}
            </Col>           
        </Col>
    )
}

export default Dashboard;